// extracted by mini-css-extract-plugin
export var preview = "ProjectsPreview-module--preview--QhpeY";
export var previewImage = "ProjectsPreview-module--previewImage--BQm7b";